import { render } from "./search-input.vue?vue&type=template&id=6155660a&scoped=true"
import script from "./search-input.vue?vue&type=script&lang=js"
export * from "./search-input.vue?vue&type=script&lang=js"

import "./search-input.vue?vue&type=style&index=0&id=6155660a&lang=scss&scoped=true"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6155660a"]])

export default __exports__